export function SpeedLimitHud({ speedLimit }) {
	return (
		<div className='absolute left-1/2 top-5'>
			<div className='absolute -left-[190px] flex -translate-x-1/2 transform bg-[initial]'>
				<svg width='77' height='90' xmlns='http://www.w3.org/2000/svg'>
					<title>hud speed limit</title>
					<g>
						<path
							fill='#FFC000'
							d='M63.35,87.24H25.63c-7.48,0-13.54-6.06-13.54-13.54V28.3c0-7.48,6.06-13.54,13.54-13.54h37.72
	c7.48,0,13.54,6.06,13.54,13.54v45.4C76.89,81.18,70.83,87.24,63.35,87.24z M70.66,72.88V28.93c0-4.73-3.83-8.56-8.56-8.56H26.06
	c-4.73,0-8.56,3.83-8.56,8.56v43.95c0,4.73,3.83,8.56,8.56,8.56H62.1C66.83,81.44,70.66,77.6,70.66,72.88z'
						/>
					</g>
					<g>
						<path
							fill='#BABABA'
							d='M37.5,60.57h0.02c0.09-0.16,0.18-0.32,0.28-0.47l0.79-1.17h1.46l-1.4,1.58l1.6,2.33h-1.5l-0.94-1.61
		l-0.31,0.38v1.22h-1.22v-5.68h1.22V60.57z'
						/>
						<path
							fill='#BABABA'
							d='M40.7,60.17c0-0.49-0.02-0.9-0.03-1.25h1.02l0.06,0.53h0.02c0.17-0.25,0.51-0.62,1.18-0.62
		c0.5,0,0.9,0.26,1.07,0.66h0.02c0.14-0.2,0.32-0.36,0.5-0.47c0.22-0.13,0.46-0.19,0.74-0.19c0.75,0,1.32,0.53,1.32,1.7v2.3h-1.18
		V60.7c0-0.57-0.18-0.9-0.58-0.9c-0.28,0-0.48,0.19-0.56,0.42c-0.03,0.09-0.05,0.22-0.05,0.31v2.29h-1.18v-2.19
		c0-0.5-0.18-0.83-0.56-0.83c-0.31,0-0.5,0.24-0.57,0.44c-0.04,0.1-0.05,0.21-0.05,0.3v2.28H40.7V60.17z'
						/>
						<path
							fill='#BABABA'
							d='M47.22,63.15l1.71-5.8h0.81l-1.71,5.8H47.22z'
						/>
						<path
							fill='#BABABA'
							d='M50.23,57.15h1.22v2.23h0.02c0.13-0.17,0.29-0.3,0.48-0.4c0.18-0.1,0.41-0.15,0.63-0.15
		c0.78,0,1.37,0.54,1.37,1.71v2.29h-1.21v-2.15c0-0.51-0.18-0.86-0.63-0.86c-0.32,0-0.52,0.21-0.61,0.42
		c-0.03,0.08-0.04,0.18-0.04,0.27v2.32h-1.22V57.15z'
						/>
					</g>
					<g>
						<path
							fill='#FFC000'
							d='M31.67,67.87h1.83v6.55h3.21v1.54h-5.05V67.87z'
						/>
						<path fill='#FFC000' d='M39.64,67.87v8.08h-1.83v-8.08H39.64z' />
						<path
							fill='#FFC000'
							d='M48.06,72.86c-0.04-0.97-0.07-2.15-0.07-3.32h-0.04c-0.25,1.03-0.59,2.18-0.9,3.13l-0.98,3.15h-1.43
		l-0.86-3.13c-0.26-0.95-0.54-2.1-0.73-3.15h-0.02c-0.05,1.09-0.08,2.34-0.14,3.35l-0.14,3.07h-1.69l0.52-8.08H44l0.79,2.7
		c0.25,0.94,0.5,1.94,0.68,2.89h0.04c0.23-0.93,0.5-2,0.77-2.9l0.86-2.69h2.39l0.44,8.08h-1.79L48.06,72.86z'
						/>
						<path fill='#FFC000' d='M53.21,67.87v8.08h-1.83v-8.08H53.21z' />
						<path
							fill='#FFC000'
							d='M56.36,69.4h-2.17v-1.54h6.21v1.54h-2.21v6.55h-1.83V69.4z'
						/>
						<text
							x='44'
							y='52'
							textAnchor='middle'
							fontSize={speedLimit > 0 ? (speedLimit >= 100 ? '25' : '38') : ''}
							fill='white'
							fontFamily='Calibri'
							fontWeight='700'
							content-value={speedLimit}
						>
							{speedLimit}
						</text>
					</g>
				</svg>
			</div>
		</div>
	);
}
